import * as actions from './view.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ViewModel } from '@smarttask-common/src/lib/models/View/Core/ViewModel';

export const viewAdapter = createEntityAdapter<ViewModel>({
    selectId: (x) => x.view_id,
});
export interface ViewState extends EntityState<ViewModel> {
    selected_view_id: string;
}

export const initialState: ViewState = viewAdapter.getInitialState({
    selected_view_id: undefined,
});

export function ViewReducers(state: ViewState = initialState, action: actions.ViewActions) {
    switch (action.type) {
        case actions.ViewActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_view_id: action.selected_view_id };
            //console.log(state);
            return state;

        case actions.ViewActionTypes.ADD_VIEW:
            return viewAdapter.addOne(action.view, state);

        case actions.ViewActionTypes.ADD_VIEWS:
            return viewAdapter.addMany(action.views, state);

        case actions.ViewActionTypes.UPSERT_VIEW:
            return viewAdapter.upsertOne(action.view, state);

        case actions.ViewActionTypes.UPSERT_VIEWS:
            return viewAdapter.upsertMany(action.views, state);

        case actions.ViewActionTypes.UPDATE_VIEW:
            return viewAdapter.updateOne(action.view, state);

        case actions.ViewActionTypes.UPDATE_VIEWS:
            return viewAdapter.updateMany(action.views, state);

        case actions.ViewActionTypes.DELETE_VIEW:
            // if(state.selectedViewId == action.id){
            //   state.selectedViewId = undefined;
            // }
            return viewAdapter.removeOne(action.id, state);

        case actions.ViewActionTypes.DELETE_VIEWS:
            // if(action.ids.indexOf(state.selectedViewId) > -1){
            //   state.selectedViewId = undefined;
            // }
            return viewAdapter.removeMany(action.ids, state);

        case actions.ViewActionTypes.DELETE_ALL_VIEWS:
            return viewAdapter.removeMany(action.ids, state);

        case actions.ViewActionTypes.DELETE_ALL:
            return viewAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getViewState = createFeatureSelector<ViewState>('view');

export const { selectIds, selectEntities, selectAll, selectTotal } = viewAdapter.getSelectors(getViewState);

const getSelectedViewIdState = (state: ViewState) => {
    return state.selected_view_id;
};
export const getSelectedViewId = createSelector(getViewState, getSelectedViewIdState);

export const getSelectedView = createSelector(getViewState, (state: ViewState) => {
    if (state.selected_view_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_view_id];
});
